// Copyright (c) 2017 TrainHeroic LLC
// WorkoutSet schema

import { schema } from 'normalizr';
import savedWorkoutSetExerciseSchema from '../savedWorkoutSetExercise/schema';

const savedWorkoutSetSchema = new schema.Entity(
    'addedSets',
    {
        addedExercises: new schema.Array(savedWorkoutSetExerciseSchema)
    },
    {
        idAttribute: entity => entity.saved_workout_set_id,
        processStrategy: entity => {
            const item = { ...entity };
            item.addedExercises = item.exercises;
            return item;
        }
    }
);

export default savedWorkoutSetSchema;



// WEBPACK FOOTER //
// ./src/state/reducer/savedWorkoutSet/schema.js